<template>
  <div id="app">
    <Layout>
      <router-view />
    </Layout>
  </div>
</template>
<script>
import Layout from '@/layouts/Default.vue';
import api from '@/api';

export default {
  components: { Layout },
  created() {
    api.get('/hello');
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.$buefy.snackbar.open({
          duration: 10000,
          message:
            'Nova versão disponível! Atualize agora para ter acesso aos últimos recursos',
          type: 'is-danger',
          position: 'is-bottom-left',
          actionText: 'Atualizar',
          queue: false,
          onAction: () => {
            this.accept();
          },
        });
      });
    }
  },

  methods: {
    async accept() {
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' });
    },
  },
};
</script>
<style>
html,
body,
#app {
  width: 100%;
}
html,
body {
  min-height: 100%;
  height: 1px;
}
#app {
  min-height: 100vh;
  min-height: -webkit-fill-available;
  min-height: fill-available;
  height: 1px;
}
body .notices {
  z-index: 3000;
}
</style>
